import {Avatar, DatePicker, Input, Radio} from 'antd'
import classNames from 'classnames'
import React, {useContext} from 'react'
import {compose, mapProps, pure, withProps} from "recompose";
import withTranslate from "../../../../modules/local/withTranslate";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import LookupField from "../../../../components/LookupField";
import {createValue} from "../../../../components/form/utils";
import {createControlledFormField} from "../../factory/createFormField";
import Translate from "../../../../modules/local/Translate";
import {getFullAddress, renderIf} from "../../../Shared";
import {SaintsOutlineSvg} from "../../../../components/Svgs/SaintsPlaceholder";
import {gConfigs} from "../../configs";
import {PrelatesOutlineSvg} from "../../../../components/Svgs/PrelatesPlaceholder";
import {IoCalendarOutline} from "react-icons/io5";
import {MdChurch} from "react-icons/md";
import TextArea from "antd/lib/input/TextArea";
import {RiMapPinFill, RiUser2Fill} from "react-icons/ri";
import {SelectWidget} from "../../custom/ReactSelectComponents";
import _ from "lodash"
import {BiSolidChurch} from "react-icons/bi";
import {GenderTypes} from "../../appFieldTypes";
import dayjs from "dayjs";

export const RelationshipType = [
    {value: 'FATHER', label: 'father'},
    {value: 'MOTHER', label: 'mother'},
    {value: 'CHILDREN', label: 'children'},
    {value: 'OTHER', label: 'other member'},
]

export const catholicHouseholdFormSchema = {
    title: {
        children: [
            {
                description: 'title household description',
                name: 'title',
                label: 'title household',
                isRequired: true,
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('ex: title household'),
                        addonBefore: <span className="text-color-400 italic">{translate('catholic household')}</span>,
                    })),
                    pure
                )(Input),
            },
        ],
    },
    description: {
        title: 'description',
        children: [
            {
                name: 'description',
                component: createControlledFormField({
                    placeholder: 'short description',
                    className: 'scrollBarThin',
                    Component: TextArea,
                    showCount: true,
                    maxLength: 500,
                    autoSize: {minRows: 3, maxRows: 3},
                }),
            },
        ],
    },
    parish: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'belong to parish',
                name: 'parish',
                isRequired: true,
                component: ({name, value, onChange, form, ...restForm}) => {

                    return (
                        <LayoutContext.Consumer>
                            {({isSm}) => (
                                <Translate>
                                    {(t) => (
                                        <LookupField
                                            title={t('choose parish')}
                                            createIfNotExists={true}
                                            defaultValue={form?.values?.parish_name}
                                            selectedOption={form?.values?.parish}
                                            apiPath={`/lookup/parish/get-by-types`}
                                            name={name}
                                            OptionWrapper={({children, ...props}) =>
                                                <div
                                                    className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                                    {children}
                                                </div>
                                            }
                                            renderOption={(o, i) => {
                                                const {fullname, diocese_fullname, location_address} = o ?? {}
                                                return (
                                                    <div key={i} className="flex items-center flex-1 gap-3">
                                                        {renderIf(
                                                            !isSm,
                                                            <Avatar
                                                                size={50}
                                                                src={o.avatar}
                                                                className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                                icon={<MdChurch size={20} style={{color: '#dddddd'}}/>}
                                                            />
                                                        )}
                                                        <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                            <div className="space-x-1 leading-snug">
                                                    <span className="font-bold text-sm text-color-000">
                                                        {fullname}
                                                    </span>
                                                                <span
                                                                    className="font-medium text-xs text-blue-500 italic leading-snug">
                                                        {`( ${diocese_fullname} )`}
                                                    </span>
                                                            </div>
                                                            {renderIf(
                                                                location_address,
                                                                <div className="flex items-center gap-x-1">
                                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                                    <span
                                                                        className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                            {location_address}
                                                        </span>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                )
                                            }}
                                            handleChange={(e) => {
                                                form.setValues({
                                                    ...form.values,
                                                    parish: e.target,
                                                    parish_name: e.target.value,
                                                    parish_id: e.target.id,
                                                    diocese: e.target.diocese,
                                                    diocese_name: e.target?.diocese?.name,
                                                    diocese_id: e.target?.diocese?.id
                                                });
                                            }}
                                        />
                                    )}
                                </Translate>
                            )}
                        </LayoutContext.Consumer>
                    )
                },
            },
            {
                label: 'diocese',
                component: ({name, value, onChange, form, ...restForm}) => {
                    const _parish = _.get(form?.values, 'parish')
                    return (
                        <Input disabled={true} value={_.get(_parish, 'diocese_fullname')}/>
                    )
                },
            },
        ],
    },
    source_id__eff_date: {
        inline: true,
        className: 'grid grid-cols-1 sm:grid-cols-2 gap-3',
        children: [
            {
                label: 'number of households',
                name: 'source_idcode',
                description: 'catholic family record number description',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate, form}) => ({
                        name,
                        value,
                        onChange,
                        type: 'text',
                        placeholder: translate('number of catholic household'),
                    })),
                    pure
                )(Input),
            },
            {
                label: 'date of immigration',
                name: 'eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
        ],
    },

    // STEP 2
    full_name: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, selected, ...props}) =>
                                    <div
                                        className={classNames(
                                            'flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 overflow-hidden px-3 py-2.5',
                                            selected ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-color-50'
                                        )}
                                        {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => {
                                    return (
                                        <div key={i} className="flex items-center flex-1 gap-3">
                                            <Avatar
                                                size={50}
                                                src={o.avatar}
                                                className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                icon={<SaintsOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                                <span className="font-bold text-sm text-color-000 leading-snug">
                                                    {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                                </span>
                                                {renderIf(
                                                    o?.description,
                                                    <span className="text-xs text-color-400 italic max-lines-1">
                                                        {o?.description}
                                                    </span>
                                                )}
                                            </div>
                                        </div>
                                    )
                                }}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'full name',
                name: 'member_user',
                isRequired: true,
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                value={form?.values?.name || ''}
                                placeholder={t('full name')}
                                onChange={(e) => {
                                    const inputValue = e.target.value
                                    form.setValues({
                                        ...form.values,
                                        member_user: inputValue ? {value: inputValue} : null,
                                        name: inputValue,
                                        member_user_id: null
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    patron_saint_feast_day: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        children: [
            {
                label: 'patron saint feast day',
                name: 'patron_saint_feast_day',
                component: compose(
                    withTranslate,
                    withProps(({value, onChange, translate}) => ({
                        onChange: (date, dateString) => {
                            onChange(createValue('patron_saint_feast_day', dateString))
                        },
                        value: !!value ? dayjs(value, "DD/MM") : null,
                        className: 'w-full',
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        name: 'patron saint feast day',
                        placeholder: translate('patron saint feast day'),
                        format: 'DD/MM'
                    }))
                )(DatePicker),
            },
        ],
    },
    full_name_only: {
        children: [
            {
                label: 'full name',
                isRequired: true,
                name: 'member_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                value={form?.values?.name || ''}
                                placeholder={t('full name')}
                                onChange={(e) => {
                                    const inputValue = e.target.value
                                    form.setValues({
                                        ...form.values,
                                        member_user: inputValue ? {value: inputValue} : null,
                                        name: inputValue,
                                        member_user_id: null
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    date__place__gender: {
        inline: true,
        className: 'grid grid-cols-1 sm:grid-cols-3 gap-3',
        children: [
            {
                label: 'date of birth',
                name: 'birth_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: 'DD/MM/YYYY',
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'place of birth',
                name: 'province',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose place of birth')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.birth_province_name}
                                selectedOption={form?.values?.birth_province}
                                apiPath={`/lookup/province/get-by-types`}
                                name={name}
                                OptionWrapper={({children, selected, ...props}) =>
                                    <div
                                        className={classNames(
                                            'flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 overflow-hidden',
                                            selected ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-color-50'
                                        )}
                                        {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="px-3 py-2.5 font-medium text-sm text-color-000 leading-tight">
                                        {o.location_name}
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        birth_province: e.target,
                                        birth_province_id: e.target.id,
                                        birth_province_name: e.target.value
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        defaultValue: 1,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        children: Object.values(GenderTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                    }))
                )(Radio.Group),
            },
        ],
    },
    relationship_type: {
        inline: true,
        className: 'w-full',
        children: [
            {
                label: 'role in the household',
                name: 'relationship_type',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => {
                        const {isSm} = useContext(LayoutContext)
                        return {
                            name,
                            value,
                            onChange,
                            buttonStyle: 'solid',
                            style: {whiteSpace: isSm ? 'wrap' : 'nowrap'},
                            className: 'w-full custom-radio-button',
                            children: RelationshipType.map(
                                ({value, label}) => (
                                    <Radio.Button
                                        key={value}
                                        value={value}>
                                        {translate(label)}
                                    </Radio.Button>
                                )
                            ),
                        }
                    })
                )(Radio.Group),
            },
        ],
    },
    patron_saint__feast_day: {
        inline: true,
        className: 'grid grid-cols-1 sm:grid-cols-2 gap-3',
        children: [
            {
                label: 'holy name',
                name: 'patron_saint',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose patron saint')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.patron_saint_name}
                                selectedOption={form?.values?.patron_saint}
                                apiPath={`/lookup/saint/get-by-types`}
                                name={name}
                                OptionWrapper={({children, selected, ...props}) =>
                                    <div
                                        className={classNames(
                                            'flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 overflow-hidden px-3 py-2.5',
                                            selected ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-color-50'
                                        )}
                                        {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={44}
                                            src={o.avatar}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<SaintsOutlineSvg size={24} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col flex-1 min-w-0">
                                            <span className="font-semibold text-sm text-color-000 leading-snug truncate">
                                                {`${o.common_name || o.name} (${o.patron_saint_feast_day || o.feast_day})`}
                                            </span>
                                            {renderIf(
                                                o?.description,
                                                <span className="text-xs text-color-400 italic max-lines-1">
                                                    {o?.description}
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        patron_saint: e.target,
                                        patron_saint_name: e.target.common_name || e.target.value,
                                        patron_saint_feast_day: e.target.feast_day,
                                        patron_saint_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'patron saint feast day',
                name: 'patron_saint_feast_day',
                component: compose(
                    withTranslate,
                    withProps(({value, onChange, translate}) => ({
                        onChange: (date, dateString) => {
                            onChange(createValue('patron_saint_feast_day', dateString))
                        },
                        value: !!value ? dayjs(value, 'DD/MM') : null,
                        className: 'w-full',
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: translate('patron saint feast day'),
                        format: 'DD/MM'
                    }))
                )(DatePicker),
            },
        ],
    },
    gender__full_name: {
        inline: true,
        className: 'grid grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-2'],
        children: [
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        defaultValue: 1,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        children: Object.values(GenderTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                    }))
                )(Radio.Group),
            },
            {
                label: 'full name',
                name: 'member_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <Input
                                value={form?.values?.name || ''}
                                placeholder={t('full name')}
                                onChange={(e) => {
                                    const inputValue = e.target.value
                                    form.setValues({
                                        ...form.values,
                                        member_user: inputValue ? {value: inputValue} : null,
                                        name: inputValue,
                                        member_user_id: null
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    relationship_type__gender: {
        inline: true,
        className: "grid grid-cols-1 md:grid-cols-2 gap-3",
        children: [
            {
                label: 'role in the household',
                name: 'relationship_type',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => {
                        const {isSm} = useContext(LayoutContext)
                        return {
                            name,
                            value,
                            onChange,
                            buttonStyle: 'solid',
                            style: {whiteSpace: isSm ? 'wrap' : 'nowrap'},
                            className: 'w-full custom-radio-button',
                            children: RelationshipType.map(
                                ({value, label}) => (
                                    <Radio.Button
                                        key={value}
                                        value={value}>
                                        {translate(label)}
                                    </Radio.Button>
                                )
                            ),
                        }
                    })
                )(Radio.Group),
            },
            {
                label: 'gender',
                name: 'gender',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        onChange,
                        defaultValue: 1,
                        buttonStyle: 'solid',
                        className: 'w-full custom-radio-button',
                        children: Object.values(GenderTypes).map(
                            ({name, value, label}) => (
                                <Radio.Button
                                    key={name}
                                    value={value}>
                                    {translate(label)}
                                </Radio.Button>
                            )
                        ),
                    }))
                )(Radio.Group),
            },
        ]
    },
    date__place_of_birth: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-1 md:col-span-2'],
        children: [
            {
                label: 'date of birth',
                name: 'birth_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'place of birth',
                name: 'province',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose place of birth')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.birth_province_name}
                                selectedOption={form?.values?.birth_province}
                                apiPath={`/lookup/province/get-by-types`}
                                name={name}
                                OptionWrapper={({children, selected, ...props}) =>
                                    <div
                                        className={classNames(
                                            'flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 overflow-hidden',
                                            selected ? 'bg-primary-50 ring-1 ring-primary-200' : 'hover:bg-color-50'
                                        )}
                                        {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="px-3 py-3 font-medium text-sm text-color-000 leading-tight">
                                        {o.location_name}
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        birth_province: e.target,
                                        birth_province_id: e.target.id,
                                        birth_province_name: e.target.value
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    death_date: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-3 gap-3',
        itemClassNames: ['col-span-1', 'col-span-2'],
        children: [
            {
                label: 'date of death',
                name: 'death_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
        ],
    },
    parent: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'name of father',
                name: 'father_name',
                component: createControlledFormField({
                    placeholder: 'name of father',
                    Component: Input,
                    withValues: ({relationship_type}) => ({
                        disabled: relationship_type === 'CHILDREN'
                    }),
                }),
            },
            {
                label: 'name of mother',
                name: 'mother_name',
                component: createControlledFormField({
                    placeholder: 'name of mother',
                    Component: Input,
                    withValues: ({relationship_type}) => ({
                        disabled: relationship_type === 'CHILDREN'
                    }),
                }),
            },
        ],
    },

    baptism__date__church_sacrament: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'date of celebration',
                name: 'baptism_eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'baptism book no',
                name: 'baptism_source_idcode',
                component: createControlledFormField({
                    placeholder: 'baptism book no',
                    Component: Input,
                }),
            },
        ],
    },
    baptism__parish__source_id_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'church',
                name: 'baptism_church_id',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose church')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.baptism_church_name}
                                selectedOption={form?.values?.baptism_church}
                                apiPath={`/lookup/church/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                          {o.label}
                                        </span>
                                            <div className="flex items-center gap-x-1">
                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                <span
                                                    className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                {getFullAddress(o)}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        baptism_church: e.target,
                                        baptism_church_name: e.target.value,
                                        baptism_church_id: e.target.id,
                                        baptism_parish: e.target.parish,
                                        baptism_parish_name: e.target?.parish?.name,
                                        baptism_parish_id: e.target?.parish?.id,
                                        baptism_diocese: e.target.parish?.diocese,
                                        baptism_diocese_name: e.target?.parish?.diocese?.name,
                                        baptism_diocese_id: e.target?.parish?.diocese?.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'belong to parish',
                name: 'baptism_parish_id',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <LookupField
                                        title={t('choose parish')}
                                        createIfNotExists={true}
                                        defaultValue={form?.values?.baptism_parish_name}
                                        selectedOption={form?.values?.baptism_parish}
                                        apiPath={`/lookup/parish/get-by-types`}
                                        name={name}
                                        OptionWrapper={({children, ...props}) =>
                                            <div
                                                className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                                {children}
                                            </div>
                                        }
                                        renderOption={(o, i) => {
                                            const {fullname, diocese_fullname, location_address} = o ?? {}
                                            return (
                                                <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                                    {renderIf(
                                                        !isSm,
                                                        <Avatar
                                                            size={50}
                                                            src={o.cover_photo}
                                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                                                        />
                                                    )}
                                                    <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                        <div className="space-x-1 leading-snug">
                                                    <span className="font-bold text-sm text-color-000">
                                                        {fullname}
                                                    </span>
                                                            <span
                                                                className="font-medium text-xs text-blue-500 italic leading-snug">
                                                        {`( ${diocese_fullname} )`}
                                                    </span>
                                                        </div>
                                                        {renderIf(
                                                            location_address,
                                                            <div className="flex items-center gap-x-1">
                                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                                <span
                                                                    className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                {location_address}
                                                            </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        handleChange={(e) => {
                                            form.setValues({
                                                ...form.values,
                                                baptism_parish: e.target,
                                                baptism_parish_name: e.target.value,
                                                baptism_parish_id: e.target.id,
                                                baptism_diocese: e.target?.diocese,
                                                baptism_diocese_name: e.target?.diocese?.name,
                                                baptism_diocese_id: e.target?.diocese?.id
                                            })
                                        }}
                                    />
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    baptism__officiant__participant_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'celebrant',
                name: 'baptism_officiant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose celebrant')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.baptism_officiant_name}
                                selectedOption={form?.values?.baptism_officiant_user}
                                apiPath={`/lookup/prelate/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<PrelatesOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                          <span className="font-bold text-sm text-color-000 leading-snug">
                              {o.label}
                          </span>
                                            {renderIf(
                                                o?.position_title,
                                                <span className="font-medium text-xs text-blue-500 italic">
                                  {t(o?.position_title || '')}
                              </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        baptism_officiant_user: e.target,
                                        baptism_officiant_name: e.target.value,
                                        baptism_officiant_user_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'godparent',
                name: 'baptism_participant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose godparent')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.baptism_participant_name}
                                selectedOption={form?.values?.baptism_participant_user}
                                apiPath={`/lookup/user/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<RiUser2Fill size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                      <span className="font-bold text-sm text-color-000 leading-snug">
                          {renderIf(
                              o?.patron_saint_name,
                              <span className="mr-1 font-bold text-color-100 italic">{o?.patron_saint_name}</span>
                          )}
                          {o.label}
                      </span>
                                            <span className="text-xs text-color-400 italic leading-snug">
                        {o?.email}
                      </span>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        baptism_participant_user: e.target,
                                        baptism_participant_name: e.target.value,
                                        baptism_participant_user_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    first_communion__date__church_sacrament: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'date of celebration',
                name: 'first_communion_eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'first communion book no',
                name: 'first_communion_source_idcode',
                component: createControlledFormField({
                    placeholder: 'first communion book no',
                    Component: Input,
                }),
            },
        ],
    },
    first_communion__parish__source_id_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'church',
                name: 'first_communion_church_id',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose church')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.first_communion_church_name}
                                selectedOption={form?.values?.first_communion_church}
                                apiPath={`/lookup/church/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                          {o.label}
                                        </span>
                                            <div className="flex items-center gap-x-1">
                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                <span
                                                    className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                {getFullAddress(o)}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    // onChange(createValue('first_communion_church', e.target))
                                    // onChange(createValue('first_communion_church_name', e.target.value))
                                    // onChange(createValue('first_communion_church_id', e.target.id))
                                    form.setValues({
                                        ...form.values,
                                        first_communion_church: e.target,
                                        first_communion_church_name: e.target.value,
                                        first_communion_church_id: e.target.id,
                                        first_communion_parish: e.target?.parish,
                                        first_communion_parish_name: e.target?.parish?.name,
                                        first_communion_parish_id: e.target?.parish?.id,
                                        first_communion_diocese: e.target.parish?.diocese,
                                        first_communion_diocese_name: e.target?.parish?.diocese?.name,
                                        first_communion_diocese_id: e.target?.parish?.diocese?.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'belong to parish',
                name: 'first_communion_parish',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <LookupField
                                        title={t('choose parish')}
                                        createIfNotExists={true}
                                        defaultValue={form?.values?.first_communion_parish_name}
                                        selectedOption={form?.values?.first_communion_parish}
                                        apiPath={`/lookup/parish/get-by-types`}
                                        name={name}
                                        OptionWrapper={({children, ...props}) =>
                                            <div
                                                className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                                {children}
                                            </div>
                                        }
                                        renderOption={(o, i) => {
                                            const {fullname, diocese_fullname, location_address} = o ?? {}
                                            return (
                                                <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                                    {renderIf(
                                                        !isSm,
                                                        <Avatar
                                                            size={50}
                                                            src={o.cover_photo}
                                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                                                        />
                                                    )}
                                                    <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                        <div className="space-x-1 leading-snug">
                                                    <span className="font-bold text-sm text-color-000">
                                                        {fullname}
                                                    </span>
                                                            <span
                                                                className="font-medium text-xs text-blue-500 italic leading-snug">
                                                        {`( ${diocese_fullname} )`}
                                                    </span>
                                                        </div>
                                                        {renderIf(
                                                            location_address,
                                                            <div className="flex items-center gap-x-1">
                                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                                <span
                                                                    className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                {location_address}
                                                            </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        handleChange={(e) => {
                                            form.setValues({
                                                ...form.values,
                                                first_communion_parish: e.target,
                                                first_communion_parish_name: e.target.value,
                                                first_communion_parish_id: e.target.id,
                                                first_communion_diocese: e.target.diocese,
                                                first_communion_diocese_name: e.target.diocese?.name,
                                                first_communion_diocese_id: e.target.diocese?.id
                                            })
                                        }}
                                    />
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    first_communion__officiant__participant_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'celebrant',
                name: 'first_communion_officiant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose celebrant')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.first_communion_officiant_name}
                                selectedOption={form?.values?.first_communion_officiant_user}
                                apiPath={`/lookup/prelate/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<PrelatesOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                              <span className="font-bold text-sm text-color-000 leading-snug">
                                  {o.label}
                              </span>
                                            {renderIf(
                                                o?.position_title,
                                                <span className="font-medium text-xs text-blue-500 italic">
                                      {t(o?.position_title || '')}
                                  </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        first_communion_officiant_user: e.target,
                                        first_communion_officiant_name: e.target.value,
                                        first_communion_officiant_user_id: e.target.id
                                    })
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    confirmation__date__church_sacrament: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'date of celebration',
                name: 'confirmation_eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'confirmation book no',
                name: 'confirmation_source_idcode',
                component: createControlledFormField({
                    placeholder: 'confirmation book no',
                    Component: Input,
                }),
            },
        ],
    },
    confirmation__parish__source_id_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'church',
                name: 'confirmation_church_id',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose church')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.confirmation_church_name}
                                selectedOption={form?.values?.confirmation_church}
                                apiPath={`/lookup/church/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                          {o.label}
                                        </span>
                                            <div className="flex items-center gap-x-1">
                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                <span
                                                    className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                {getFullAddress(o)}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        confirmation_church: e.target,
                                        confirmation_church_name: e.target.value,
                                        confirmation_church_id: e.target.id,
                                        confirmation_parish: e.target.parish,
                                        confirmation_parish_name: e.target?.parish?.name,
                                        confirmation_parish_id: e.target?.id,
                                        confirmation_diocese: e.target.parish?.diocese,
                                        confirmation_diocese_name: e.target?.parish?.diocese?.name,
                                        confirmation_diocese_id: e.target?.parish?.diocese?.id
                                    })

                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'belong to parish',
                name: 'confirmation_parish',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <LookupField
                                        title={t('choose parish')}
                                        createIfNotExists={true}
                                        defaultValue={form?.values?.confirmation_parish_name}
                                        selectedOption={form?.values?.confirmation_parish}
                                        apiPath={`/lookup/parish/get-by-types`}
                                        name={name}
                                        OptionWrapper={({children, ...props}) =>
                                            <div
                                                className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                                {children}
                                            </div>
                                        }
                                        renderOption={(o, i) => {
                                            const {fullname, diocese_fullname, location_address} = o ?? {}
                                            return (
                                                <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                                    {renderIf(
                                                        !isSm,
                                                        <Avatar
                                                            size={50}
                                                            src={o.cover_photo}
                                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                                                        />
                                                    )}
                                                    <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                        <div className="space-x-1 leading-snug">
                                                    <span className="font-bold text-sm text-color-000">
                                                        {fullname}
                                                    </span>
                                                            <span
                                                                className="font-medium text-xs text-blue-500 italic leading-snug">
                                                        {`( ${diocese_fullname} )`}
                                                    </span>
                                                        </div>
                                                        {renderIf(
                                                            location_address,
                                                            <div className="flex items-center gap-x-1">
                                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                                <span
                                                                    className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                {location_address}
                                                            </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        handleChange={(e) => {
                                            form.setValues({
                                                ...form.values,
                                                confirmation_parish: e.target,
                                                confirmation_parish_name: e.target.value,
                                                confirmation_parish_id: e.target.id,
                                                confirmation_diocese: e.target.diocese,
                                                confirmation_diocese_name: e.target?.diocese?.name,
                                                confirmation_diocese_id: e.target?.diocese?.id
                                            });
                                        }}
                                    />
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    confirmation__officiant__participant_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'celebrant',
                name: 'confirmation_officiant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose celebrant')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.confirmation_officiant_name}
                                selectedOption={form?.values?.confirmation_officiant_user}
                                apiPath={`/lookup/prelate/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<PrelatesOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o.label}
                            </span>
                                            {renderIf(
                                                o?.position_title,
                                                <span className="font-medium text-xs text-blue-500 italic">
                                    {t(o?.position_title || '')}
                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    // onChange(createValue('confirmation_officiant_user', e.target))
                                    // onChange(createValue('confirmation_officiant_name', e.target.value))
                                    // onChange(createValue('confirmation_officiant_user_id', e.target.id))
                                    form.setValues({
                                        ...form.values,
                                        confirmation_officiant_user: e.target,
                                        confirmation_officiant_name: e.target.value,
                                        confirmation_officiant_user_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'godparent',
                name: 'confirmation_participant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose godparent')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.confirmation_participant_name}
                                selectedOption={form?.values?.confirmation_participant_user}
                                apiPath={`/lookup/user/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<RiUser2Fill size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                      <span className="font-bold text-sm text-color-000 leading-snug">
                          {renderIf(
                              o?.patron_saint_name,
                              <span className="mr-1 font-bold text-color-100 italic">{o?.patron_saint_name}</span>
                          )}
                          {o.label}
                      </span>
                                            <span className="text-xs text-color-400 italic leading-snug">
                        {o?.email}
                      </span>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    // onChange(createValue('confirmation_participant_user', e.target))
                                    // onChange(createValue('confirmation_participant_name', e.target.value))
                                    // onChange(createValue('confirmation_participant_user_id', e.target.id))
                                    form.setValues({
                                        ...form.values,
                                        confirmation_participant_user: e.target,
                                        confirmation_participant_name: e.target.value,
                                        confirmation_participant_user_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    matrimony__date__church_sacrament: {
        inline: true,
        className: 'grid grid-cols-2 gap-3',
        children: [
            {
                label: 'date of celebration',
                name: 'matrimony_eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'marriage book no',
                name: 'matrimony_source_idcode',
                component: createControlledFormField({
                    placeholder: 'marriage book no',
                    Component: Input,
                }),
            },
        ],
    },
    matrimony__parish__source_id_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'church',
                name: 'matrimony_church_id',
                component: ({name, value, onChange, form, ...restForm}) => {
                    return (
                        <Translate>
                            {(t) => (
                                <LookupField
                                    title={t('choose church')}
                                    createIfNotExists={true}
                                    defaultValue={form?.values?.matrimony_church_name}
                                    selectedOption={form?.values?.matrimony_church}
                                    apiPath={`/lookup/church/get-by-types`}
                                    name={name}
                                    OptionWrapper={({children, ...props}) =>
                                        <div
                                            className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                            {children}
                                        </div>
                                    }
                                    renderOption={(o, i) => (
                                        <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                            <Avatar
                                                size={50}
                                                src={o.photo}
                                                className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                            />
                                            <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                          {o.label}
                                        </span>
                                                <div className="flex items-center gap-x-1">
                                                    <RiMapPinFill size={11} className="text-color-400"/>
                                                    <span
                                                        className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                {getFullAddress(o)}
                                            </span>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                    handleChange={(e) => {
                                        form.setValues({
                                            ...form.values,
                                            matrimony_church: e.target,
                                            matrimony_church_name: e.target.value,
                                            matrimony_church_id: e.target.id,
                                            matrimony_parish: e.target.parish,
                                            matrimony_parish_name: e.target?.parish?.name,
                                            matrimony_parish_id: e.target?.parish?.id,
                                            matrimony_diocese: e.target.parish?.diocese,
                                            matrimony_diocese_name: e.target?.parish?.diocese?.name,
                                            matrimony_diocese_id: e.target?.parish?.diocese?.id
                                        })
                                    }}
                                />
                            )}
                        </Translate>
                    )
                },
            },
            {
                label: 'belong to parish',
                name: 'matrimony_parish',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <LayoutContext.Consumer>
                        {({isSm}) => (
                            <Translate>
                                {(t) => (
                                    <LookupField
                                        title={t('choose parish')}
                                        createIfNotExists={true}
                                        defaultValue={form?.values?.matrimony_parish_name}
                                        selectedOption={form?.values?.matrimony_parish}
                                        apiPath={`/lookup/parish/get-by-types`}
                                        name={name}
                                        OptionWrapper={({children, ...props}) =>
                                            <div
                                                className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                                {children}
                                            </div>
                                        }
                                        renderOption={(o, i) => {
                                            const {fullname, diocese_fullname, location_address} = o ?? {}
                                            return (
                                                <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                                    {renderIf(
                                                        !isSm,
                                                        <Avatar
                                                            size={50}
                                                            src={o.cover_photo}
                                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                                            icon={<MdChurch size={30} style={{color: '#dddddd'}}/>}
                                                        />
                                                    )}
                                                    <div className="py-2 md:py-0 flex flex-col flex-1 min-w-0 gap-1">
                                                        <div className="space-x-1 leading-snug">
                                                    <span className="font-bold text-sm text-color-000">
                                                        {fullname}
                                                    </span>
                                                            <span
                                                                className="font-medium text-xs text-blue-500 italic leading-snug">
                                                        {`( ${diocese_fullname} )`}
                                                    </span>
                                                        </div>
                                                        {renderIf(
                                                            location_address,
                                                            <div className="flex items-center gap-x-1">
                                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                                <span
                                                                    className="flex-1 max-lines-1 text-xs text-color-400 italic leading-snug">
                                                                {location_address}
                                                            </span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            )
                                        }}
                                        handleChange={(e) => {
                                            form.setValues({
                                                ...form.values,
                                                matrimony_parish: e.target,
                                                matrimony_parish_name: e.target.value,
                                                matrimony_parish_id: e.target.id,
                                                matrimony_diocese: e.target.diocese,
                                                matrimony_diocese_name: e.target?.diocese?.name,
                                                matrimony_diocese_id: e.target?.diocese?.id
                                            });
                                        }}
                                    />
                                )}
                            </Translate>
                        )}
                    </LayoutContext.Consumer>
                ),
            },
        ],
    },
    matrimony__officiant__participant_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'celebrant',
                name: 'matrimony_officiant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose celebrant')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.matrimony_officiant_name}
                                selectedOption={form?.values?.matrimony_officiant_user}
                                apiPath={`/lookup/prelate/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<PrelatesOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o.label}
                            </span>
                                            {renderIf(
                                                o?.position_title,
                                                <span className="font-medium text-xs text-blue-500 italic">
                                    {t(o?.position_title || '')}
                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        matrimony_officiant_user: e.target,
                                        matrimony_officiant_name: e.target.value,
                                        matrimony_officiant_user_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
            {
                label: 'marriage witnesses',
                name: 'matrimony_participant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('marriage witnesses')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.matrimony_participant_name}
                                selectedOption={form?.values?.matrimony_participant_user}
                                apiPath={`/lookup/user/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<RiUser2Fill size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                                    <span className="font-bold text-sm text-color-000 leading-snug">
                                {renderIf(
                                    o?.patron_saint_name,
                                    <span className="mr-1 font-bold text-color-100 italic">{o?.patron_saint_name}</span>
                                )}
                                        {o.label}
                            </span>
                                            <span className="text-xs text-color-400 italic leading-snug">
                                {o?.email}
                            </span>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        matrimony_participant_user: e.target,
                                        matrimony_participant_name: e.target.value,
                                        matrimony_participant_user_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    holy_orders__date__church_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'date of celebration',
                name: 'holy_orders_eff_date',
                component: compose(
                    withTranslate,
                    mapProps(({name, value, onChange, translate}) => ({
                        name,
                        value,
                        className: 'w-full',
                        format: gConfigs.dateFormat,
                        suffixIcon: <IoCalendarOutline className="text-color-500"/>,
                        placeholder: "DD/MM/YYYY",
                        onChange: (date) => {
                            onChange(createValue(name, date ? dayjs(new Date(date)) : null))
                        },
                    }))
                )(DatePicker),
            },
            {
                label: 'church',
                name: 'holy_orders_church_id',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                title={t('choose church')}
                                createIfNotExists={true}
                                defaultValue={form?.values?.holy_orders_church_name}
                                selectedOption={form?.values?.holy_orders_church}
                                apiPath={`/lookup/church/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-2 md:gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<BiSolidChurch size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col flex-1">
                                        <span className="font-bold text-sm text-color-000 leading-snug">
                                          {o.label}
                                        </span>
                                            <div className="flex items-center gap-x-1">
                                                <RiMapPinFill size={11} className="text-color-400"/>
                                                <span
                                                    className="max-lines-1 flex-1 text-xs text-color-400 italic leading-snug">
                                                {getFullAddress(o)}
                                            </span>
                                            </div>
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        holy_orders_church: e.target,
                                        holy_orders_church_name: e.target.value,
                                        holy_orders_church_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },
    holy_orders__officiant__parish_sacrament: {
        inline: true,
        className: 'grid grid-cols-1 md:grid-cols-2 gap-3',
        children: [
            {
                label: 'celebrant',
                name: 'holy_orders_officiant_user',
                component: ({name, value, onChange, form, ...restForm}) => (
                    <Translate>
                        {(t) => (
                            <LookupField
                                createIfNotExists={true}
                                defaultValue={form?.values?.holy_orders_officiant_name}
                                selectedOption={form?.values?.holy_orders_officiant_user}
                                apiPath={`/lookup/prelate/get-by-types`}
                                name={name}
                                OptionWrapper={({children, ...props}) =>
                                    <div
                                        className="flex items-center gap-3 rounded-xl cursor-pointer transition-all duration-150 hover:bg-primary-50 overflow-hidden" {...props}>
                                        {children}
                                    </div>
                                }
                                renderOption={(o, i) => (
                                    <div key={i} className="flex items-center flex-1 gap-3">
                                        <Avatar
                                            size={50}
                                            src={o.cover_photo}
                                            className="flex flex-center background-200 rounded-lg flex-shrink-0"
                                            icon={<PrelatesOutlineSvg size={30} style={{color: '#dddddd'}}/>}
                                        />
                                        <div className="flex flex-col">
                            <span className="font-bold text-sm text-color-000 leading-snug">
                                {o.label}
                            </span>
                                            {renderIf(
                                                o?.position_title,
                                                <span className="font-medium text-xs text-blue-500 italic">
                                    {t(o?.position_title || '')}
                                </span>
                                            )}
                                        </div>
                                    </div>
                                )}
                                handleChange={(e) => {
                                    form.setValues({
                                        ...form.values,
                                        holy_orders_officiant_user: e.target,
                                        holy_orders_officiant_name: e.target.value,
                                        holy_orders_officiant_user_id: e.target.id
                                    });
                                }}
                            />
                        )}
                    </Translate>
                ),
            },
        ],
    },

    // STEP 3
    contact_name: {
        title: 'full name',
        children: [
            {
                name: 'contact_name',
                component: createControlledFormField({
                    placeholder: 'full name',
                    Component: Input,
                }),
            },
        ]
    },
    contact_phone: {
        inline: true,
        className: 'grid grid-cols-1 sm:grid-cols-2 gap-3',
        children: [
            {
                label: 'phone',
                name: 'contact_phone',
                component: createControlledFormField({
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
            {
                label: 'alternative phone',
                name: 'contact_phone2',
                component: createControlledFormField({
                    type: 'tel',
                    placeholder: 'ex: phone',
                    Component: Input,
                }),
            },
        ],
    },
    contact_address: {
        title: 'address',
        children: [
            {
                name: 'contact_address',
                component: createControlledFormField({
                    placeholder: 'ex: address',
                    Component: Input,
                }),
            },
        ]
    },
    father_of_household: {
        title: 'husband',
        children: [
            {
                name: 'household_father_id',
                component: createControlledFormField({
                    withValues: (values) => ({
                        options: _.get(values, 'catholic_household_members', [])
                            .filter(e => e?.relationship_type === 'FATHER')
                            .map((e, i) => {
                                const fullname = [e?.patron_saint?.name || e?.patron_saint_name, e?.member_user?.name || e?.name].join(" ")
                                return {
                                    id: e.id,
                                    value: e.id,
                                    label: <span className="font-medium">{fullname}</span>
                                }
                            }),
                    }),
                    withProps: ({name, onChange}) => ({
                        onChange: (value, option) => {
                            onChange(createValue(name, option))
                        },
                    }),
                    className: 'w-full',
                    placeholder: 'click to select',
                    Component: SelectWidget,
                }),
            },
        ]
    },
    mother_of_household: {
        title: 'wife',
        children: [
            {
                name: 'household_mother_id',
                component: createControlledFormField({
                    withValues: (values) => ({
                        options: _.get(values, 'catholic_household_members', [])
                            .filter(e => e?.relationship_type === 'MOTHER')
                            .map((e, i) => {
                                const fullname = [e?.patron_saint?.name || e?.patron_saint_name, e?.member_user?.name || e?.name].join(" ")
                                return {
                                    id: e.id,
                                    value: e.id,
                                    label: <span className="font-medium">{fullname}</span>
                                }
                            }),
                    }),
                    withProps: ({name, onChange}) => ({
                        onChange: (value, option) => {
                            onChange(createValue(name, option))
                        },
                    }),
                    className: 'w-full',
                    placeholder: 'click to select',
                    Component: SelectWidget,
                }),
            },
        ]
    },
    head_of_household: {
        title: 'head of household',
        children: [
            {
                name: 'household_head_id',
                component: createControlledFormField({
                    withValues: (values) => ({
                        options: _.get(values, 'catholic_household_members', []).map((e, i) => {
                            const fullname = [e?.patron_saint?.name || e?.patron_saint_name, e?.member_user?.name || e?.name].join(" ")
                            return {
                                id: e.id,
                                value: e.id,
                                label: fullname
                            }
                        }),
                    }),
                    withProps: ({name, onChange}) => ({
                        onChange: (value, option) => {
                            onChange(createValue(name, option))
                        },
                    }),
                    className: 'w-full',
                    Component: SelectWidget,
                }),
            },
        ]
    },
}
